import React from "react";
import { useLang } from "../i18n/LanguageContext";

export default function SiteFooter() {
  const { t } = useLang();
  return (
    <footer style={{
      width: "100%",
      maxWidth: 520,
      margin: "32px auto 0",
      padding: "20px 20px 48px",
      borderTop: "1px solid #2B2A26",
      boxSizing: "border-box",
    }}>
      <div style={{
        fontSize: "0.72rem",
        color: "#8C8677",
        lineHeight: 2.1,
        marginBottom: 14,
      }}>
        <span style={{ color: "#8C8677", fontWeight: 700 }}>{t("footer.lblBizName")}</span>: {t("footer.valBizName")} &nbsp;|&nbsp;{" "}
        <span style={{ color: "#8C8677", fontWeight: 700 }}>{t("footer.lblRep")}</span>: {t("footer.valRep")} &nbsp;|&nbsp;{" "}
        <span style={{ color: "#8C8677", fontWeight: 700 }}>{t("footer.lblBizNo")}</span>: 517-04-03594<br />
        <span style={{ color: "#8C8677", fontWeight: 700 }}>{t("footer.lblMailOrder")}</span>: {t("footer.valMailOrder")} &nbsp;|&nbsp;{" "}
        <span style={{ color: "#8C8677", fontWeight: 700 }}>{t("footer.lblContact")}</span>: 010-4282-2377<br />
        <span style={{ color: "#8C8677", fontWeight: 700 }}>{t("footer.lblAddress")}</span>: {t("footer.valAddress")}<br />
        <span style={{ color: "#8C8677", fontWeight: 700 }}>{t("footer.lblEmail")}</span>: wooyeonsaju@gmail.com
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 14px" }}>
        <a href="/legal/terms" target="_blank" rel="noreferrer"
          style={{ fontSize: "0.72rem", color: "#8C8677", textDecoration: "underline" }}>
          {t("footer.linkTerms")}
        </a>
        <a href="/legal/privacy" target="_blank" rel="noreferrer"
          style={{ fontSize: "0.72rem", color: "#8C8677", textDecoration: "underline" }}>
          {t("footer.linkPrivacy")}
        </a>
        <a href="/legal/refund" target="_blank" rel="noreferrer"
          style={{ fontSize: "0.72rem", color: "#8C8677", textDecoration: "underline" }}>
          {t("footer.linkRefund")}
        </a>
      </div>
    </footer>
  );
}
